module.exports = __webpack_public_path__ + "static/media/AdobeStock_299103030.0311f058.jpg";